<template>
  <div class="typography-alignment-content" id="identidade-visual-tipografia-alinhamento" data-search-anchor>
    <div class="title-typography-alignment-wrapper">
      <h1 class="typography-alignment-span">{{ typographyAlignmentTitleSpan }}</h1>
      <h1 class="typography-alignment-title">{{ typographyAlignmentTitle }}</h1>
    </div>
    <div class="description-typography-alignment-wrapper">
      <p class="typography-alignment-description">{{ typographyAlignmentDescription }}</p>
      <div>
        <div class="typography-alignment-icon">
          <IconCheck />
          <p class="typography-alignment-description2">
            {{ typographyAlignmentDescription1 }}
          </p>
        </div>        
      </div>
      <div class="typography-alignment-icon">
        <IconCheck />
        <p class="typography-alignment-description2">{{ typographyAlignmentDescription2 }}</p>
      </div>
    </div>
    <div
      class="typography-alignment-card-item"
      :style="{ backgroundImage: `url(${typographyAlignmentImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import TypographyPageMixin from '@/mixins/typography-page-mixin'
import { TypographyPageStore } from '@/store/visual-identity-page/typography-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class TypographyAlignmentSection extends Mixins(TypographyPageMixin) {
  typographyPageStore: PageStoreContract = getModule(TypographyPageStore, this.$store)

  get typographyAlignmentTitleSpan(): string {
    return this.getElementTitle(5, 0)
  }

  get typographyAlignmentTitle(): string {
    return this.getElementText(5, 0)
  }

  get typographyAlignmentDescription(): string {
    return this.getElementText(5, 1)
  }

  get typographyAlignmentDescription1(): string {
    return this.getElementText(5, 2)
  }

  get typographyAlignmentDescription2(): string {
    return this.getElementText(5, 3)
  }

  get typographyAlignmentImageSrc(): string {
    return this.getElementMedia(5, 4)
  }

  async getTypographyPage(): Promise<void> {
    await this.typographyPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.typographyPageStore.isLoading) {
      await this.getTypographyPage()
    }
  }
}
</script>

<style lang="scss">
.typography-alignment-content {
  max-width: 100%;
  display: grid;
  width: 100%;
}

.title-typography-alignment-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 1rem;
}

.typography-alignment-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.typography-alignment-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.typography-alignment-icon {
  display: flex;
  align-items: center;
}

.description-typography-alignment-wrapper {
  position: relative;  

  display: grid;
  grid-template-columns: 51.4% 48.6%;    
}

.typography-alignment-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  width: 430px;
}

.typography-alignment-description2 {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  padding-left: 7px;

  width: 378px;
}

.typography-alignment-card-item {
  position: relative;  

  max-width: 1032px;
  width: 100%;
  height: 710px;

  border-radius: 8px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain
}
</style>
